enum SDCDropdownSize {
  Default,
  Small,
}

export default SDCDropdownSize;
